import script from "./WarningModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./WarningModal.vue?vue&type=script&setup=true&lang=ts"

import "./WarningModal.vue?vue&type=style&index=0&id=f921d14a&scoped=true&lang=css"

import exportComponent from "/node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f921d14a"]])

export default __exports__